// extracted by mini-css-extract-plugin
export default {"popularCategories":"PopularCategories_popularCategories__VPkvZ","title":"PopularCategories_title__5MaOX","categories":"PopularCategories_categories__g4Zfd"};